#import "~/graphql/fragments/sections/default/defaultSection.graphql"
#import "~/graphql/fragments/sections/grants/grantArchiveSection.graphql"
#import "~/graphql/fragments/sections/info/infoSection.graphql"
#import "~/graphql/fragments/sections/programmes/programmeSection.graphql"
#import "~/graphql/fragments/seo/index.graphql"

query getPage(
    $site: [String]
    $siteId: [QueryArgument]
    $slug: [String!]
    $id: [QueryArgument!]
    $uri: [String!]
) {
    entry(
        site: $site,
        siteId: $siteId,
        slug: $slug,
        id: $id,
        uri: $uri
    ) {
        id
        siteId
        slug
        uri
        title
        __typename
        ... defaultSection
        ... grantArchiveSection
        ... infoSection
        ... on programme_Entry {
            ... programmeSection
        }
        ... on page_Entry {
            seo {
                ... socialFragment
            }
        }
    }
}
